import Swiper from "swiper";
import { Navigation } from "swiper/modules";

export const sliderFacilities = (function () {
  const init = function () {
    const swiper = new Swiper(".slider-facilities", {
      modules: [Navigation],
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
        },
        375: {
          slidesPerView: 2,
        },
        581: {
          slidesPerView: "auto",
          allowTouchMove: false,
        },
      },
    });
  };

  return {
    init,
  };
})();
